import React from 'react'
import { Select } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'
import { setWithdrawalsFilterStatus, withdrawalsSelector } from 'src/features'

const FilterWithdrawalByStatus: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { filterStatus } = useAppSelector(withdrawalsSelector)
  const { width } = useWindowSize()
  const isMobile = width <= 800

  const handleChange = (value: 'ALL' | 'pending') => {
    dispatch(setWithdrawalsFilterStatus(value))
  }

  return (
    <Select
      value={filterStatus}
      onChange={handleChange}
      style={{ width: isMobile ? '100%' : '90%' }}
      className={isMobile && 'mb-2'}
    >
      <Select.Option value={'pending'}>{t('Deposits.Pending')}</Select.Option>
      <Select.Option value={'ALL'}>{t('Messages.All')}</Select.Option>
    </Select>
  )

}

export default FilterWithdrawalByStatus
